/*
 *
 * Services Api
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 */

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/address/address')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getCountries () {
  let data
  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/address/countries'
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getProvinces () {
  let data
  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/address/provinces'
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getMunicipalities (params) {
  const searchMunicipalityName = params.searchMunicipalityName || ''
  const provinceId = params.provinceId || ''
  let data

  const url = `/services/merchant-service/address/municipalities?searchMunicipalityName=${searchMunicipalityName}&provinceId=${provinceId}`

  try {
    data = await axios({
      method: 'get',
      url,
      params: {
        // searchMunicipalityName,
        // provinceId
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getMunicipalitiesWithCustom (params) {
  const searchMunicipalityName = params.searchMunicipalityName || ''
  const provinceId = params.provinceId || ''
  const provinceCode = params.provinceCode || ''
  let data

  const url = `/services/merchant-service/address/municipalitiesWithCustom?searchMunicipalityName=${searchMunicipalityName}&provinceId=${provinceId}&provinceCode=${provinceCode}`

  try {
    data = await axios({
      method: 'get',
      url,
      params: {
        // searchMunicipalityName,
        // provinceId
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getCheckForeignMunicipality (params) {
  const searchMunicipalityName = params.searchMunicipalityName || ''
  let data

  const url = `/services/merchant-service/address/checkForeignMunicipality?searchMunicipalityName=${searchMunicipalityName}`

  try {
    data = await axios({
      method: 'get',
      url,
      params: {
        // searchMunicipalityName,
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getStreets (params) {
  let data
  const searchStreetName = params.searchStreetName || ''
  const municipalityId = params.municipalityId || ''

  const url = `/services/merchant-service/address/streets?searchStreetName=${searchStreetName}&municipalityId=${municipalityId}`

  try {
    data = await axios({
      method: 'get',
      url,
      params: {
        // searchStreetName,
        // municipalityId
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

// @generator api:method
